// extracted by mini-css-extract-plugin
export default {"container":"Register_container__ahvex","success":"Register_success__KnIIG","error":"Register_error__xDPcr","info":"Register_info__r1hWN"};